import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface GetCustomDomainSettingRequest {
  site_luid: string;
}

export interface CustomDomainSettingResponse extends IResult {
  site_luid: string;
  custom_domain: string;
  intermediate_domain: string;
  status: string;
  request_initiation_date?: Date;
  tls_certificate_uploaded_date?: Date;
  tls_certificate_expiry_date?: Date;
  certificate_update_in_progress?: boolean;
  last_error?: string;
}

export interface GetCustomDomainRequest {
  site_luid: string;
}

export interface CustomDomainResponse extends IResult {
  site_luid: string;
  custom_domain: string;
}

export interface DeleteCustomDomainSettingRequest {
  site_luid: string;
}

export interface AddOrUpdateCustomDomainSettingRequest {
  site_luid: string;
  custom_domain: string;
  status: string;
  tls_certificate?: string;
  tls_certificate_private_key?: string;
}

export enum Status {
  requested = 'Requested',
  cnameVerificationRequested = 'CnameVerificationRequested',
  cnameVerificationInProgress = 'CnameVerificationInProgress',
  cnameVerificationFailed = 'CnameVerificationFailed',
  cnameVerificationSuccess = 'CnameVerificationSuccess',
  sslCertUploaded = 'SslCertUploaded',
  provisioning = 'Provisioning',
  provisioningFailed = 'ProvisioningFailed',
  deleting = 'Deleting',
  deletionFailed = 'DeletionFailed',
  customDomainProvisioned = 'CustomDomainProvisioned'
}